import React from "react";
import { useTheme } from "@material-ui/core/styles";

import styles from "./KodeEffects.module.css";

/**
 * Пять эффектов — и больше ничего. Все выключены в светлой теме: дымка, сетка
 * и скан-линия на #f4f4f5 читаются как дефекты печати, а не как приём.
 */
const useEffectsEnabled = () => useTheme().palette.type === "dark";

export const KodeHaze = ({ position = "topLeft" }) => {
  const positionClass = {
    topLeft: styles.hazeTopLeft,
    topRight: styles.hazeTopRight,
    center: styles.hazeCenter,
  }[position];
  return useEffectsEnabled() ? (
    <div className={`${styles.layer} ${styles.haze} ${positionClass}`} aria-hidden="true" />
  ) : null;
};

export const KodeGrid = () =>
  useEffectsEnabled() ? (
    <div className={`${styles.layer} ${styles.grid}`} aria-hidden="true" />
  ) : null;

export const KodeScan = () =>
  useEffectsEnabled() ? (
    <div className={`${styles.layer} ${styles.scan}`} aria-hidden="true" />
  ) : null;

// Координаты заданы руками, без layout-алгоритма и без случайности:
// граф детерминирован и его можно отревьюить глазами.
const NODES = [
  [18, 30],
  [52, 14],
  [86, 40],
  [30, 74],
  [64, 62],
  [104, 78],
  [12, 108],
  [48, 124],
  [92, 116],
  [126, 52],
  [136, 100],
  [72, 96],
];
const EDGES = [
  [0, 1],
  [1, 2],
  [0, 3],
  [3, 4],
  [1, 4],
  [4, 2],
  [2, 9],
  [4, 5],
  [3, 6],
  [6, 7],
  [7, 11],
  [11, 4],
  [7, 8],
  [8, 5],
  [5, 10],
  [9, 10],
  [8, 10],
  [11, 8],
];
const PULSING_EDGES = [1, 7, 12];

export const KodeNodes = () => {
  if (!useEffectsEnabled()) {
    return null;
  }
  return (
    <svg
      className={`${styles.layer} ${styles.nodes}`}
      viewBox="0 0 152 140"
      width="280"
      height="258"
      aria-hidden="true"
      focusable="false"
    >
      {EDGES.map(([from, to], index) => (
        <line
          key={`${from}-${to}`}
          x1={NODES[from][0]}
          y1={NODES[from][1]}
          x2={NODES[to][0]}
          y2={NODES[to][1]}
          stroke={PULSING_EDGES.includes(index) ? "var(--kode-accent)" : "var(--kode-hairline)"}
          strokeWidth="1"
          className={PULSING_EDGES.includes(index) ? styles.nodesEdgePulse : undefined}
          style={
            PULSING_EDGES.includes(index)
              ? { animationDelay: `${index * 0.4}s` }
              : undefined
          }
        />
      ))}
      {NODES.map(([x, y]) => (
        <circle key={`${x}-${y}`} cx={x} cy={y} r="2" fill="var(--kode-fg-muted)" />
      ))}
    </svg>
  );
};
